import { COIN_COLORS } from 'look-back/constants';

export const getColor = (index: number) => COIN_COLORS[index % COIN_COLORS.length];
